import React, { useState, useContext, useEffect } from "react";

import { userAvatars, getUserAvatars, subscriptionStatuses } from "../../data";


// import "../PAlauncher.css";
import styled, { css } from "styled-components";
import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  Button,
  StatusDot,
  Checkbox,
  Subheader,
  Head,
  Card,
  TreeSelect,
  Pagination,
  Input,
  RadioGroup,
  TagSelector,
  Switch,
  Icon,
  ButtonAction,
  ContentBlock,
  Tag,
  Notification
} from "xsolla-uikit";

import {
  PApopChangeEmail,
  PApopChangeDate,
  PApopStop
} from "./PAusersSubscribersPage";

import PAmodal from "../PApop";

import {
  PAchart1,
  PAchart2fake,
  PAchartMap
} from "../PAcharts";
import {
  PAlogin0fake,
  PAloginSocialfake,

  PAchart1fake,
  PAchart2
} from "../PAchart2";

import { subsPlans } from "../../data/subsPlans";

import { PAusersSubsTable } from "./PAusersSubsTable";


import {
  PAconnectorInv,
  PAconnectorZapier,
  PAconnectorMCH
} from "../PAconnectors";

import {
  ButtonSquare,
  PAinfoCollapsible,
  CssClick,
  CssThTd,
  CssThFilt0,
  CssCounter,
  PaSelectMultiple
} from '../uikit2';
import { PAusersSubsPop } from "./PAusersSubsPop";











export const allColumns = [
  {
    label: 'Status',
    value: 'status',
    width: '1.8fr',
    required: true,
  },
  {
    label: 'Internal id',
    value: 'internal',
    width: '1fr',
  },
  {
    label: 'Subscription plan',
    value: 'plan',
    width: '2.1fr',
    // required: true,
  },
  {
    label: 'Email / Username or ID',
    value: 'email',
    width: '3.4fr',
    // required: true,
  },
  {
    label: 'Start date',
    value: 'dateCreation',
    width: '1.4fr',
    // required: true,
  },
  {
    label: 'End date',
    value: 'dateEnd',
    width: '1.8fr',
    // required: true,
  },
  {
    label: 'Next charge',
    value: 'dateNext',
    width: '1.4fr',
    required: true,
  },
  {
    label: 'Comment',
    value: 'comment',
    width: '1.6fr',
    // required: true,
  },
  {
    label: 'Charge',
    value: 'charge',
    width: '1.2fr',
    // required: true,
  },

  {
    label: 'Action',
    value: 'action',
    width: '0.8fr',
  },

  {
    label: 'Info',
    value: 'info',
    width: '1fr',
  },

]


let colsInitial = [
  'email',
  'internal',
  'plan',
  // 'dateCreation',
  'dateNext',
  'status',
  'charge',
  // 'action',
  // 'comment',
]













export default function PAusersSubscribers({
  history
 }) {
  const [pop, setPop] = useState(false);
  const [columns, setColumns] = useState([...colsInitial]);

  return (
    <FormGroup indentation="xs">
      {pop !== false && (
          <PAmodal
            appearance="md"
            header="User details"
            footer={false}
            handleModal={setPop(false)}
          >
        <PAusersSubsPop
          index={pop}
        />
        </PAmodal>
      )}

      <FormGroup indentation="xs">
        {/* <PAtableFilter history={history}
          columns={columns}
          handleColumns = {setColumns}
        /> */}
        <PAtableFilterOld history={history}
          columns={columns}
          handleColumns = {setColumns}
        />
      </FormGroup>


      <FormGroup indentation="xs">
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <div className="">
            <strong>12,123 subscribers filtered (123,332 total)</strong>
          </div>
          <div style={{display: 'flex',}}>
            Export&nbsp;&nbsp;
            <Button appearance="secondary" size="sm" appearance="flatten"><Icon name="download"/>XLS</Button>&nbsp;&nbsp;
            <Button appearance="secondary" size="sm" appearance="flatten"><Icon name="download"/>CSV</Button>
          </div>
        </div>
      </FormGroup>

      <FormGroup indentation="xs">
        <PAusersSubsTable
          columns = {columns}
          type="subscribers"
          handleClick={id => {
            history.history.push(`/support/subscribers/${id}`)
            // setPopEm(id);
          }}
        />
      </FormGroup>



      <FormGroup indentation="lg">
        <div style={{display: 'flex', justifyContent: 'center',}}>
          <div className="pagination pagination--size-md">
            <div className="pagination_container"><a className="pagination_item pagination_item--current">1</a><a className="pagination_item">2</a><a className="pagination_item">3</a><a className="pagination_item">4</a><a className="pagination_item">5</a><a className="pagination_item">6</a><a className="pagination_item">7</a><a className="pagination_item pagination_item--disabled">...</a><a className="pagination_item">16</a></div>
          </div>
        </div>
        <br/>
      </FormGroup>

    </FormGroup>
  );
}













export const CssPopGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 220px);
`;








export const PAtableFilter = ({
  columns = [],
  handleColumns = ()=>void(0),
  history
}) => {


  // const [columns, setColumns] = useState([...columns])


  return (
    <FormGroup indentation="xs">
      <div
        style={{
          display: "grid",
          // gridTemplateColumns: "repeat( auto-fit, minmax(160px, 1fr) )",
          gridTemplateColumns: '200px 200px 220px 418px',
          gridColumnGap: 16,
        }}
      >
        <FormGroup label="Project"  indentation="xs">

          <Select
            // align="right"
            name=""
            size="sm"
            options={[
              { label: "All projects", value: 0 },
              { label: <span style={{display: 'inline-flex', alignItems: 'center'}}><StatusDot status="enabled" />&nbsp;&nbsp;Project 1</span>, extraLabel: 'ID: 91232', value: 1 },
              { label: <span style={{display: 'inline-flex', alignItems: 'center'}}><StatusDot status="enabled" />&nbsp;&nbsp;Project 123</span>, extraLabel: 'ID: 43244', value: 2 },
              { label: <span style={{display: 'inline-flex', alignItems: 'center'}}><StatusDot status="testing" />&nbsp;&nbsp;My test project</span>, extraLabel: 'ID: 324324', value: 3 },
            ]}
            input={{
              name: "widgTheme",
              value: 0,
              onChange: () => {
                void 0;
              }
            }}
          />

        </FormGroup>





        <FormGroup label="Search" indentation="xs">
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 44px',
            gridColumnGap: 16}}
          >
            <Input
              key="1"
              size="sm"
              offset="left"
              icon="search"
              placeholder="Username or email"
              input={{
                name: "1"
                // onFocus: handleFocus,
                // onChange: e => {
                //   let val = e.target.value;
                //   setInp(val);
                // }
              }}
            />
            <ButtonSquare><Icon name="search"/></ButtonSquare>
            </div>
          </FormGroup>



        <FormGroup label="Period" indentation="xs">
          <div style={{ position: "relative", display: "inline-block" }}>
            <div style={{ display: "inline-block" }}>
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  display: "inline-block"
                }}
              >
                <button
                  name="period"
                  value="9/1/2019 — 9/30/2019"
                  placeholder="Select dates"
                  className="xsui-input xsui-input--size-sm xsui-input--appearance-primary xsui-input--offset-left-separated xsui-input--read-only"
                  type="button"
                  data-id="period"
                  data-value="9/1/2019 — 9/30/2019"
                >
                  9/1/2019 — 9/30/2019
                </button>
                <div className="xsui-input__icon">
                  <i
                    className="xsui-icon xsui-icon-calendar"
                    style={{ fontSize: 24, color: "inherit" }}
                  />
                </div>
              </div>
              <div />
            </div>
            <div />
          </div>
        </FormGroup>





        <FormGroup label="Show columns">
          <PaSelectMultiple
            handleSelect={handleColumns}
            size="sm"
            options ={allColumns}
            initial = {colsInitial}
          />
        </FormGroup>

      </div>







    </FormGroup>
  );
};










export const PAtableFilterOld = ({}) => {

  const setPlain = (stats) => stats.map((oneStat) => ({
    ...oneStat,
    label: oneStat['label2']
  }))
  const setPlainPlans = (stats) => stats.map((oneStat) => ({
    ...oneStat,
    label: oneStat['label']
  }))



  const [plans, setPlans] = useState(subsPlans)
  const [stats, setStats] = useState(setPlain([...statuses]))

  return (
    <FormGroup indentation="xs">
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat( auto-fill, minmax(160px, 210px) )",

          // gridT emplateColumns: "1fr 1fr 1fr 2fr",
          width: '100%',
          gridColumnGap: 16,
          // marginBottom: 24
        }}
      >



        <FormGroup label="Subscription plan">
          <TreeSelect
              size="sm"
              // disabled={this.disabled}
              searchable={true}
              name="basic"
              allowMultiSelect={true}
              input={{
                value: plans,
                onChange: multiple => setPlans(multiple)
              }}
              options={subsPlans.map((sPlan, ind) => ({
                label: sPlan["label"],
                extraLabel: sPlan["price"],
                id: sPlan["id"]
              }))}
            />
        </FormGroup>

        <FormGroup label="Subsctiption status">
          <TreeSelect
            size="sm"
            // disabled={this.disabled}
            name="basic"
            allowMultiSelect={true}
            input={{
              value: stats,
              onChange: multiple => setStats(setPlain(multiple))
            }}
            options={[...statuses]}
          />

        </FormGroup>


        <FormGroup label="Search by username/email">
          <Input
            key="1"
            size="sm"
            offset="left"
            icon="search"
            placeholder="Username or email"
            input={{
              name: "1"
              // onFocus: handleFocus,
              // onChange: e => {
              //   let val = e.target.value;
              //   setInp(val);
              // }
            }}
          />
        </FormGroup>



        <FormGroup label="Period">
        <div className="l_flex">

          <div style={{ position: "relative", display: "inline-block" }}>
            <div style={{ display: "inline-block" }}>
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  display: "inline-block"
                }}
              >
                <button
                  name="period"
                  value="9/1/2019 — 9/30/2019"
                  placeholder="Select dates"
                  className="xsui-input xsui-input--size-sm xsui-input--appearance-primary xsui-input--offset-left-separated xsui-input--read-only"
                  type="button"
                  data-id="period"
                  data-value="9/1/2019 — 9/30/2019"
                >
                  9/1/2019 — 9/30/2019
                </button>
                <div className="xsui-input__icon">
                  <i
                    className="xsui-icon xsui-icon-calendar"
                    style={{ fontSize: 24, color: "inherit" }}
                  />
                </div>
              </div>
              <div />
            </div>
            <div />
          </div>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button appearance="secondary" size="sm">Search</Button>&nbsp;&nbsp;
            <Button appearance="flatten" size="sm">Clear</Button>
          </div>

        </FormGroup>



      </div>
    </FormGroup>
  );
};







export const PAsupportProjectSelect = ({ //TODO: not used
  columns = [...colsInitial],
  setColumns = ()=>void(0)
}) => {
  return (
    <FormGroup indentation="xs">
        <Select
          // align="right"
          name=""
          size="sm"
          options={[
            { label: "All projects", value: 0 },
            { label: <span style={{display: 'inline-flex', alignItems: 'center'}}><StatusDot status="enabled" />&nbsp;&nbsp;Project 1</span>, extraLabel: 'ID: 91232', value: 1 },
            { label: <span style={{display: 'inline-flex', alignItems: 'center'}}><StatusDot status="enabled" />&nbsp;&nbsp;Project 123</span>, extraLabel: 'ID: 43244', value: 2 },
            { label: <span style={{display: 'inline-flex', alignItems: 'center'}}><StatusDot status="testing" />&nbsp;&nbsp;My test project</span>, extraLabel: 'ID: 324324', value: 3 },
          ]}
          input={{
            name: "widgTheme",
            value: 0,
            onChange: () => {
              void 0;
            }
          }}
        />
    </FormGroup>
  )
}







export const PAcolumnsTags = ({ //TODO: not used
  items= [...allColumns],
  columns = [...colsInitial],
  setColumns = ()=>void(0)
}) => {
  return (
    <TagSelector
      name="locales"
      items={items}
      fields={{
        getAll: () => items,
        push: a => setColumns([...columns, a]),
        remove: index => {
          const newCols = [...columns];
          newCols.splice(index, 1);
          console.log('newCols = ', newCols);
          setColumns([...newCols]);
        }
      }}
    />
  )
}


export const PAfilterPlansDropdown = ({}) => { //TODO: not used
  return (
    <FormGroup label="Subscription plan">
    <Select
      // align="right"
      name=""
      size="sm"
      searchable={true}
      options={[
        {
          label: 'All plans',
          value: 0,
        },
        {
          label: 'Backer',
          extraLabel: '$1.99',
          value: 1,
        },
        {
          label: 'Gods Favor',
          extraLabel: '$19.99',
          value: 2,
        },
        {
          label: 'Ultimate premium',
          extraLabel: '$29.99',
          value: 3,
        },
      ]}
      input={{
        name: "widgTheme",
        value: 0,
        onChange: () => {
          void 0;
        }
      }}
    />
  </FormGroup>
  )
}



const statuses = [
  {
    id: "active",
    value: "active",
    customIcon: <CssCounter>12.023</CssCounter>,
    label: <StatusDot status="enabled">Active</StatusDot>,
    label2: 'Active',
    iconAlign: 'right',
  },
  {
    id: "canceled",
    value: "canceled",
    label: <StatusDot status="disabled">Cancelled</StatusDot>,
    label2: 'Cancelled',
    customIcon: <CssCounter>3</CssCounter>,
    iconAlign: 'right',
  },
  {
    id: "renewing",
    value: "renewing",
    label: <StatusDot status="testing">Non renewing</StatusDot>,
    label2: 'Non renewing',
    customIcon: <CssCounter>12</CssCounter>,
    iconAlign: 'right',
  },
  {
    id: "trial",
    value: "trial",
    label: <StatusDot status="processing-outline">In trial</StatusDot>,
    label2: 'In trial',
    customIcon: <CssCounter>20.021</CssCounter>,
    iconAlign: 'right',
  },
  {
    id: "expired",
    value: "expired",
    label: <StatusDot status="error">Expired</StatusDot>,
    label2: 'Expired',
    customIcon: <CssCounter>354</CssCounter>,
    iconAlign: 'right',
  }
]



export const PAfilterStatusesDropdown = ({}) => { //TODO: not used
  return (
    <FormGroup label="Subsctiption status"  indentation="xs">
    <Select
      // disabled={this.disabled}
      name=""
      size="sm"
      options={[...statuses]}
      // searchable={this.searchable}
      // autosize={this.autosize}
      // size={this.size}
      input={{
        value: "all",
        onChange: () => {
          void 0;
        }
      }}
    />
  </FormGroup>
  )
}




export const CssSelectItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
  margin: 0px 0 0 0px;
`;

